import _ from 'lodash';
import $ from 'jquery';
import 'normalize.css';
import 'jquery-validation';
import 'jquery-modal';

require('webpack-jquery-ui');
require('webpack-jquery-ui/css');

window.jQuery = $;
window.$ = $;

// Styles

import './global.scss';
import './assets/styles/top-menu.scss';
import './assets/styles/side-bar.scss';
import './assets/styles/footer.scss';


function checkScrollHeight(height) {
  // console.log(height);
  // console.log($(window).scrollTop());
  // if($(window).scrollTop() > height) {
  //   $('#top-menu').addClass('fixed');
  // }
  // else{
  //   $('#top-menu').removeClass('fixed');
  // }
}

$(window).scroll(function() {
  // const height = $("#top-menu").outerHeight();
  // checkScrollHeight(height);
});

$(window).on('load', function () {

  // const height = $("#top-menu").outerHeight();
  // checkScrollHeight(height);

  $(".se-pre-con").fadeOut("slow");
});
